import React from 'react';
import Input from 'antd/lib/input';
import { SearchOutlined } from '@ant-design/icons';
import { t } from 'utils/i18n';

interface Props {
    search: string;
    onSearch(value: string): void;
    placeholder?: string;
    // icon actions, right of the search field
    children?: React.ReactNode;
}

// one line: a borderless search field and the list-wide toggles
export default function SidebarToolbar({
    search, onSearch, placeholder = t('Search by label'), children,
}: Props): JSX.Element {
    return (
        <div className='cvat-sidebar-toolbar'>
            <Input
                allowClear
                bordered={false}
                size='small'
                className='cvat-sidebar-search'
                prefix={<SearchOutlined />}
                placeholder={placeholder}
                aria-label={t('Search by label')}
                value={search}
                onChange={(event) => onSearch(event.target.value)}
            />
            <span className='cvat-sidebar-toolbar-actions'>{children}</span>
        </div>
    );
}
